import { PocRadio } from 'commons/components/components-wrapper/poc-radio.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { TRANSL_STRG_AUT_RULES } from '../constants/common';
import { OnChangeAutomationRuleStateData } from '../types/automation-rules.type';

export enum ButtonValues {
    equals = 'EQUALS',
    not_equals = 'NOT_EQUALS',
}

const ButtonValuesConst = [ButtonValues.equals, ButtonValues.not_equals];
const ButtonValuesKeys = Object.keys(ButtonValues);

interface AutomationRulesRadioButtonsConditionProps {
    name: string;
    defaultValue?: ButtonValues;
    type: string;
    onChange: (data: OnChangeAutomationRuleStateData) => void;
}

export const AutomationRulesRadioButtonsConditionComponent = (props: AutomationRulesRadioButtonsConditionProps) => {
    const { name, defaultValue, type, onChange } = props;
    const { t } = useTranslation();
    const [checkedItem, setCheckedItem] = React.useState<ButtonValues>(defaultValue || ButtonValuesConst[0]);

    const valueChangeHandler = (value: ButtonValues) => () => {
        const data = { key: name, value, type };

        onChange(data);
        setCheckedItem(value);
    };

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            {ButtonValuesKeys.map((el, index) => {
                const value = ButtonValuesConst[index];
                return (
                    <PocRadio
                        key={`${value}-radio-button`}
                        value={value}
                        checked={checkedItem === value}
                        onClick={valueChangeHandler(value)}
                    >
                        {t(TRANSL_STRG_AUT_RULES + el)}
                    </PocRadio>
                );
            })}
        </div>
    );
};
